import { useMemo } from "react";
import { isFieldVisibleForGender } from "../utils/isFieldVisibleForGender";

const resolvePhoneSyncCountryField = (fields) => {
    const countryFields = fields.filter((field) => (field.type || "").toLowerCase() === "country");
    if (countryFields.length === 0) {
        return null;
    }

    // Forms may include multiple Country fields (e.g. nationality, citizenship, address).
    // Phone prefix sync should follow the address country when available.
    const addressCountryByName = countryFields.find((field) => (field.name || "").toLowerCase() === "country");
    if (addressCountryByName) {
        return addressCountryByName;
    }

    const addressCountryBySection = countryFields.find(
        (field) => (field.section || "").toLowerCase() === "address"
    );
    if (addressCountryBySection) {
        return addressCountryBySection;
    }

    return countryFields[0];
};

export const useDynamicFormConfig = ({ config, siteConfig, selectedGender, hideLogo = false }) => {
    const genderField = useMemo(
        () => config.fields.find((f) => (f.type || "").toLowerCase() === "gender" || f.name === "gender"),
        [config.fields]
    );

    const countryField = useMemo(
        () => resolvePhoneSyncCountryField(config.fields),
        [config.fields]
    );

    const phoneField = useMemo(
        () => config.fields.find((f) => (f.type || "").toLowerCase() === "phone"),
        [config.fields]
    );

    const hasCountryPhoneSync = Boolean(countryField && phoneField);

    const visibleFields = useMemo(() => {
        return config.fields.filter((field) => isFieldVisibleForGender(field, selectedGender));
    }, [config.fields, selectedGender]);

    const logoUrl = useMemo(() => {
        // With the site header above the form the same logo would appear twice.
        if (hideLogo) return undefined;
        if (siteConfig?.logo) return siteConfig.logo;
        if (config.logo) return config.logo;
        return undefined;
    }, [hideLogo, siteConfig?.logo, config.logo]);

    return {
        genderField,
        countryField,
        hasCountryPhoneSync,
        visibleFields,
        logoUrl,
    };
};
